export const EligibilityError = 'Unable to load eligibility page';
